var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"visual-map-wrapper",style:(_vm.gradientStyle)},[_vm._l((_vm.visualMapName),function(item,index){return [_c('div',{key:index,staticClass:"name"},[_vm._v(_vm._s(item))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }